/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as UnauthenticatedIndexRouteImport } from './routes/_unauthenticated/index'
import { Route as UnauthenticatedRequestPasswordResetRouteImport } from './routes/_unauthenticated/request-password-reset'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as UnauthenticatedAccountTypeLoginRouteImport } from './routes/_unauthenticated/accountTypeLogin'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as UnauthenticatedSetupIndexRouteImport } from './routes/_unauthenticated/setup/index'
import { Route as UnauthenticatedSetupTermsAgreementRouteImport } from './routes/_unauthenticated/setup/terms-agreement'
import { Route as UnauthenticatedSetupPaymentSelectionRouteImport } from './routes/_unauthenticated/setup/payment-selection'
import { Route as UnauthenticatedSetupPasswordCreationRouteImport } from './routes/_unauthenticated/setup/password-creation'
import { Route as UnauthenticatedSetupIdentitySupportRouteImport } from './routes/_unauthenticated/setup/identity-support'
import { Route as UnauthenticatedSetupEmailVerificationRouteImport } from './routes/_unauthenticated/setup/email-verification'
import { Route as UnauthenticatedSetupCreateLinkRouteImport } from './routes/_unauthenticated/setup/create-link'
import { Route as UnauthenticatedSetupCheckExistingAccountRouteImport } from './routes/_unauthenticated/setup/check-existing-account'
import { Route as UnauthenticatedSetupBranchInformationalRouteImport } from './routes/_unauthenticated/setup/branch-informational'
import { Route as UnauthenticatedRegistrationTokenExchangeRouteImport } from './routes/_unauthenticated/registration/token-exchange'
import { Route as AuthenticatedAccountDebitCardRouteImport } from './routes/_authenticated/account/debit-card'
import { Route as AuthenticatedAccountDashboardRouteRouteImport } from './routes/_authenticated/account/_dashboard.route'
import { Route as AuthenticatedAccountAccountDetailsRouteRouteImport } from './routes/_authenticated/account/_accountDetails.route'
import { Route as AuthenticatedAccountDashboardIndexRouteImport } from './routes/_authenticated/account/_dashboard.index'
import { Route as UnauthenticatedRegistrationPasswordExchangeRouteImport } from './routes/_unauthenticated/registration/password.exchange'
import { Route as AuthenticatedAccountAccountDetailsPersonalInfoRouteImport } from './routes/_authenticated/account/_accountDetails.personalInfo'
import { Route as AuthenticatedAccountAccountDetailsConnectedDebitCardsRouteImport } from './routes/_authenticated/account/_accountDetails.connectedDebitCards'
import { Route as AuthenticatedAccountDashboardOnDemandPayRouteRouteImport } from './routes/_authenticated/account/_dashboard.onDemandPay.route'
import { Route as AuthenticatedAccountDashboardOnDemandPayIndexRouteImport } from './routes/_authenticated/account/_dashboard.onDemandPay.index'
import { Route as AuthenticatedAccountDashboardOnDemandPayReportedWorkRouteImport } from './routes/_authenticated/account/_dashboard.onDemandPay.reportedWork'
import { Route as UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteImport } from './routes/_unauthenticated/registration/organizations.$orgId.exchange.route'
import { Route as UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRouteImport } from './routes/_unauthenticated/registration/organizations.$orgId.exchange.index'

const UnauthenticatedSetupAdditionalInfoLazyRouteImport = createFileRoute(
  '/_unauthenticated/setup/additional-info',
)()
const UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRouteImport =
  createFileRoute(
    '/_unauthenticated/registration/organizations/$orgId/exchange/workerPasscode',
  )()
const UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRouteImport =
  createFileRoute(
    '/_unauthenticated/registration/organizations/$orgId/exchange/orgPasscode',
  )()

const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedIndexRoute = UnauthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedRequestPasswordResetRoute =
  UnauthenticatedRequestPasswordResetRouteImport.update({
    id: '/request-password-reset',
    path: '/request-password-reset',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedAccountTypeLoginRoute =
  UnauthenticatedAccountTypeLoginRouteImport.update({
    id: '/accountTypeLogin',
    path: '/accountTypeLogin',
    getParentRoute: () => UnauthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_unauthenticated/accountTypeLogin.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const UnauthenticatedSetupIndexRoute =
  UnauthenticatedSetupIndexRouteImport.update({
    id: '/setup/',
    path: '/setup/',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSetupAdditionalInfoLazyRoute =
  UnauthenticatedSetupAdditionalInfoLazyRouteImport.update({
    id: '/setup/additional-info',
    path: '/setup/additional-info',
    getParentRoute: () => UnauthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_unauthenticated/setup/additional-info.lazy').then(
      (d) => d.Route,
    ),
  )
const UnauthenticatedSetupTermsAgreementRoute =
  UnauthenticatedSetupTermsAgreementRouteImport.update({
    id: '/setup/terms-agreement',
    path: '/setup/terms-agreement',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSetupPaymentSelectionRoute =
  UnauthenticatedSetupPaymentSelectionRouteImport.update({
    id: '/setup/payment-selection',
    path: '/setup/payment-selection',
    getParentRoute: () => UnauthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_unauthenticated/setup/payment-selection.lazy').then(
      (d) => d.Route,
    ),
  )
const UnauthenticatedSetupPasswordCreationRoute =
  UnauthenticatedSetupPasswordCreationRouteImport.update({
    id: '/setup/password-creation',
    path: '/setup/password-creation',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSetupIdentitySupportRoute =
  UnauthenticatedSetupIdentitySupportRouteImport.update({
    id: '/setup/identity-support',
    path: '/setup/identity-support',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSetupEmailVerificationRoute =
  UnauthenticatedSetupEmailVerificationRouteImport.update({
    id: '/setup/email-verification',
    path: '/setup/email-verification',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSetupCreateLinkRoute =
  UnauthenticatedSetupCreateLinkRouteImport.update({
    id: '/setup/create-link',
    path: '/setup/create-link',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSetupCheckExistingAccountRoute =
  UnauthenticatedSetupCheckExistingAccountRouteImport.update({
    id: '/setup/check-existing-account',
    path: '/setup/check-existing-account',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSetupBranchInformationalRoute =
  UnauthenticatedSetupBranchInformationalRouteImport.update({
    id: '/setup/branch-informational',
    path: '/setup/branch-informational',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedRegistrationTokenExchangeRoute =
  UnauthenticatedRegistrationTokenExchangeRouteImport.update({
    id: '/registration/token-exchange',
    path: '/registration/token-exchange',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedAccountDebitCardRoute =
  AuthenticatedAccountDebitCardRouteImport.update({
    id: '/debit-card',
    path: '/debit-card',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountDashboardRouteRoute =
  AuthenticatedAccountDashboardRouteRouteImport.update({
    id: '/_dashboard',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountAccountDetailsRouteRoute =
  AuthenticatedAccountAccountDetailsRouteRouteImport.update({
    id: '/_accountDetails',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountDashboardIndexRoute =
  AuthenticatedAccountDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/account/_dashboard.index.lazy').then(
      (d) => d.Route,
    ),
  )
const UnauthenticatedRegistrationPasswordExchangeRoute =
  UnauthenticatedRegistrationPasswordExchangeRouteImport.update({
    id: '/registration/password/exchange',
    path: '/registration/password/exchange',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedAccountAccountDetailsPersonalInfoRoute =
  AuthenticatedAccountAccountDetailsPersonalInfoRouteImport.update({
    id: '/personalInfo',
    path: '/personalInfo',
    getParentRoute: () => AuthenticatedAccountAccountDetailsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/account/_accountDetails.personalInfo.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedAccountAccountDetailsConnectedDebitCardsRoute =
  AuthenticatedAccountAccountDetailsConnectedDebitCardsRouteImport.update({
    id: '/connectedDebitCards',
    path: '/connectedDebitCards',
    getParentRoute: () => AuthenticatedAccountAccountDetailsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/account/_accountDetails.connectedDebitCards.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedAccountDashboardOnDemandPayRouteRoute =
  AuthenticatedAccountDashboardOnDemandPayRouteRouteImport.update({
    id: '/onDemandPay',
    path: '/onDemandPay',
    getParentRoute: () => AuthenticatedAccountDashboardRouteRoute,
  } as any)
const AuthenticatedAccountDashboardOnDemandPayIndexRoute =
  AuthenticatedAccountDashboardOnDemandPayIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountDashboardOnDemandPayRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/account/_dashboard.onDemandPay.index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedAccountDashboardOnDemandPayReportedWorkRoute =
  AuthenticatedAccountDashboardOnDemandPayReportedWorkRouteImport.update({
    id: '/reportedWork',
    path: '/reportedWork',
    getParentRoute: () => AuthenticatedAccountDashboardOnDemandPayRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/account/_dashboard.onDemandPay.reportedWork.lazy'
    ).then((d) => d.Route),
  )
const UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute =
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteImport.update({
    id: '/registration/organizations/$orgId/exchange',
    path: '/registration/organizations/$orgId/exchange',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRoute =
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute,
  } as any)
const UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRoute =
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRouteImport.update(
    {
      id: '/workerPasscode',
      path: '/workerPasscode',
      getParentRoute: () =>
        UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_unauthenticated/registration/organizations.$orgId.exchange.workerPasscode.lazy'
    ).then((d) => d.Route),
  )
const UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRoute =
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRouteImport.update(
    {
      id: '/orgPasscode',
      path: '/orgPasscode',
      getParentRoute: () =>
        UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_unauthenticated/registration/organizations.$orgId.exchange.orgPasscode.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/account': typeof AuthenticatedAccountDashboardRouteRouteWithChildren
  '/accountTypeLogin': typeof UnauthenticatedAccountTypeLoginRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/request-password-reset': typeof UnauthenticatedRequestPasswordResetRoute
  '/': typeof UnauthenticatedIndexRoute
  '/account/debit-card': typeof AuthenticatedAccountDebitCardRoute
  '/registration/token-exchange': typeof UnauthenticatedRegistrationTokenExchangeRoute
  '/setup/branch-informational': typeof UnauthenticatedSetupBranchInformationalRoute
  '/setup/check-existing-account': typeof UnauthenticatedSetupCheckExistingAccountRoute
  '/setup/create-link': typeof UnauthenticatedSetupCreateLinkRoute
  '/setup/email-verification': typeof UnauthenticatedSetupEmailVerificationRoute
  '/setup/identity-support': typeof UnauthenticatedSetupIdentitySupportRoute
  '/setup/password-creation': typeof UnauthenticatedSetupPasswordCreationRoute
  '/setup/payment-selection': typeof UnauthenticatedSetupPaymentSelectionRoute
  '/setup/terms-agreement': typeof UnauthenticatedSetupTermsAgreementRoute
  '/setup/additional-info': typeof UnauthenticatedSetupAdditionalInfoLazyRoute
  '/setup': typeof UnauthenticatedSetupIndexRoute
  '/account/onDemandPay': typeof AuthenticatedAccountDashboardOnDemandPayRouteRouteWithChildren
  '/account/connectedDebitCards': typeof AuthenticatedAccountAccountDetailsConnectedDebitCardsRoute
  '/account/personalInfo': typeof AuthenticatedAccountAccountDetailsPersonalInfoRoute
  '/registration/password/exchange': typeof UnauthenticatedRegistrationPasswordExchangeRoute
  '/account/': typeof AuthenticatedAccountDashboardIndexRoute
  '/registration/organizations/$orgId/exchange': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteWithChildren
  '/account/onDemandPay/reportedWork': typeof AuthenticatedAccountDashboardOnDemandPayReportedWorkRoute
  '/account/onDemandPay/': typeof AuthenticatedAccountDashboardOnDemandPayIndexRoute
  '/registration/organizations/$orgId/exchange/orgPasscode': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRoute
  '/registration/organizations/$orgId/exchange/workerPasscode': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRoute
  '/registration/organizations/$orgId/exchange/': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRoute
}
export interface FileRoutesByTo {
  '/account': typeof AuthenticatedAccountDashboardIndexRoute
  '/accountTypeLogin': typeof UnauthenticatedAccountTypeLoginRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/request-password-reset': typeof UnauthenticatedRequestPasswordResetRoute
  '/': typeof UnauthenticatedIndexRoute
  '/account/debit-card': typeof AuthenticatedAccountDebitCardRoute
  '/registration/token-exchange': typeof UnauthenticatedRegistrationTokenExchangeRoute
  '/setup/branch-informational': typeof UnauthenticatedSetupBranchInformationalRoute
  '/setup/check-existing-account': typeof UnauthenticatedSetupCheckExistingAccountRoute
  '/setup/create-link': typeof UnauthenticatedSetupCreateLinkRoute
  '/setup/email-verification': typeof UnauthenticatedSetupEmailVerificationRoute
  '/setup/identity-support': typeof UnauthenticatedSetupIdentitySupportRoute
  '/setup/password-creation': typeof UnauthenticatedSetupPasswordCreationRoute
  '/setup/payment-selection': typeof UnauthenticatedSetupPaymentSelectionRoute
  '/setup/terms-agreement': typeof UnauthenticatedSetupTermsAgreementRoute
  '/setup/additional-info': typeof UnauthenticatedSetupAdditionalInfoLazyRoute
  '/setup': typeof UnauthenticatedSetupIndexRoute
  '/account/connectedDebitCards': typeof AuthenticatedAccountAccountDetailsConnectedDebitCardsRoute
  '/account/personalInfo': typeof AuthenticatedAccountAccountDetailsPersonalInfoRoute
  '/registration/password/exchange': typeof UnauthenticatedRegistrationPasswordExchangeRoute
  '/account/onDemandPay/reportedWork': typeof AuthenticatedAccountDashboardOnDemandPayReportedWorkRoute
  '/account/onDemandPay': typeof AuthenticatedAccountDashboardOnDemandPayIndexRoute
  '/registration/organizations/$orgId/exchange/orgPasscode': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRoute
  '/registration/organizations/$orgId/exchange/workerPasscode': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRoute
  '/registration/organizations/$orgId/exchange': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/_authenticated/account': typeof AuthenticatedAccountRouteWithChildren
  '/_unauthenticated/accountTypeLogin': typeof UnauthenticatedAccountTypeLoginRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/_unauthenticated/request-password-reset': typeof UnauthenticatedRequestPasswordResetRoute
  '/_unauthenticated/': typeof UnauthenticatedIndexRoute
  '/_authenticated/account/_accountDetails': typeof AuthenticatedAccountAccountDetailsRouteRouteWithChildren
  '/_authenticated/account/_dashboard': typeof AuthenticatedAccountDashboardRouteRouteWithChildren
  '/_authenticated/account/debit-card': typeof AuthenticatedAccountDebitCardRoute
  '/_unauthenticated/registration/token-exchange': typeof UnauthenticatedRegistrationTokenExchangeRoute
  '/_unauthenticated/setup/branch-informational': typeof UnauthenticatedSetupBranchInformationalRoute
  '/_unauthenticated/setup/check-existing-account': typeof UnauthenticatedSetupCheckExistingAccountRoute
  '/_unauthenticated/setup/create-link': typeof UnauthenticatedSetupCreateLinkRoute
  '/_unauthenticated/setup/email-verification': typeof UnauthenticatedSetupEmailVerificationRoute
  '/_unauthenticated/setup/identity-support': typeof UnauthenticatedSetupIdentitySupportRoute
  '/_unauthenticated/setup/password-creation': typeof UnauthenticatedSetupPasswordCreationRoute
  '/_unauthenticated/setup/payment-selection': typeof UnauthenticatedSetupPaymentSelectionRoute
  '/_unauthenticated/setup/terms-agreement': typeof UnauthenticatedSetupTermsAgreementRoute
  '/_unauthenticated/setup/additional-info': typeof UnauthenticatedSetupAdditionalInfoLazyRoute
  '/_unauthenticated/setup/': typeof UnauthenticatedSetupIndexRoute
  '/_authenticated/account/_dashboard/onDemandPay': typeof AuthenticatedAccountDashboardOnDemandPayRouteRouteWithChildren
  '/_authenticated/account/_accountDetails/connectedDebitCards': typeof AuthenticatedAccountAccountDetailsConnectedDebitCardsRoute
  '/_authenticated/account/_accountDetails/personalInfo': typeof AuthenticatedAccountAccountDetailsPersonalInfoRoute
  '/_unauthenticated/registration/password/exchange': typeof UnauthenticatedRegistrationPasswordExchangeRoute
  '/_authenticated/account/_dashboard/': typeof AuthenticatedAccountDashboardIndexRoute
  '/_unauthenticated/registration/organizations/$orgId/exchange': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteWithChildren
  '/_authenticated/account/_dashboard/onDemandPay/reportedWork': typeof AuthenticatedAccountDashboardOnDemandPayReportedWorkRoute
  '/_authenticated/account/_dashboard/onDemandPay/': typeof AuthenticatedAccountDashboardOnDemandPayIndexRoute
  '/_unauthenticated/registration/organizations/$orgId/exchange/orgPasscode': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRoute
  '/_unauthenticated/registration/organizations/$orgId/exchange/workerPasscode': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRoute
  '/_unauthenticated/registration/organizations/$orgId/exchange/': typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/account'
    | '/accountTypeLogin'
    | '/login'
    | '/request-password-reset'
    | '/'
    | '/account/debit-card'
    | '/registration/token-exchange'
    | '/setup/branch-informational'
    | '/setup/check-existing-account'
    | '/setup/create-link'
    | '/setup/email-verification'
    | '/setup/identity-support'
    | '/setup/password-creation'
    | '/setup/payment-selection'
    | '/setup/terms-agreement'
    | '/setup/additional-info'
    | '/setup'
    | '/account/onDemandPay'
    | '/account/connectedDebitCards'
    | '/account/personalInfo'
    | '/registration/password/exchange'
    | '/account/'
    | '/registration/organizations/$orgId/exchange'
    | '/account/onDemandPay/reportedWork'
    | '/account/onDemandPay/'
    | '/registration/organizations/$orgId/exchange/orgPasscode'
    | '/registration/organizations/$orgId/exchange/workerPasscode'
    | '/registration/organizations/$orgId/exchange/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/account'
    | '/accountTypeLogin'
    | '/login'
    | '/request-password-reset'
    | '/'
    | '/account/debit-card'
    | '/registration/token-exchange'
    | '/setup/branch-informational'
    | '/setup/check-existing-account'
    | '/setup/create-link'
    | '/setup/email-verification'
    | '/setup/identity-support'
    | '/setup/password-creation'
    | '/setup/payment-selection'
    | '/setup/terms-agreement'
    | '/setup/additional-info'
    | '/setup'
    | '/account/connectedDebitCards'
    | '/account/personalInfo'
    | '/registration/password/exchange'
    | '/account/onDemandPay/reportedWork'
    | '/account/onDemandPay'
    | '/registration/organizations/$orgId/exchange/orgPasscode'
    | '/registration/organizations/$orgId/exchange/workerPasscode'
    | '/registration/organizations/$orgId/exchange'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/_authenticated/account'
    | '/_unauthenticated/accountTypeLogin'
    | '/_unauthenticated/login'
    | '/_unauthenticated/request-password-reset'
    | '/_unauthenticated/'
    | '/_authenticated/account/_accountDetails'
    | '/_authenticated/account/_dashboard'
    | '/_authenticated/account/debit-card'
    | '/_unauthenticated/registration/token-exchange'
    | '/_unauthenticated/setup/branch-informational'
    | '/_unauthenticated/setup/check-existing-account'
    | '/_unauthenticated/setup/create-link'
    | '/_unauthenticated/setup/email-verification'
    | '/_unauthenticated/setup/identity-support'
    | '/_unauthenticated/setup/password-creation'
    | '/_unauthenticated/setup/payment-selection'
    | '/_unauthenticated/setup/terms-agreement'
    | '/_unauthenticated/setup/additional-info'
    | '/_unauthenticated/setup/'
    | '/_authenticated/account/_dashboard/onDemandPay'
    | '/_authenticated/account/_accountDetails/connectedDebitCards'
    | '/_authenticated/account/_accountDetails/personalInfo'
    | '/_unauthenticated/registration/password/exchange'
    | '/_authenticated/account/_dashboard/'
    | '/_unauthenticated/registration/organizations/$orgId/exchange'
    | '/_authenticated/account/_dashboard/onDemandPay/reportedWork'
    | '/_authenticated/account/_dashboard/onDemandPay/'
    | '/_unauthenticated/registration/organizations/$orgId/exchange/orgPasscode'
    | '/_unauthenticated/registration/organizations/$orgId/exchange/workerPasscode'
    | '/_unauthenticated/registration/organizations/$orgId/exchange/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/': {
      id: '/_unauthenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/request-password-reset': {
      id: '/_unauthenticated/request-password-reset'
      path: '/request-password-reset'
      fullPath: '/request-password-reset'
      preLoaderRoute: typeof UnauthenticatedRequestPasswordResetRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/accountTypeLogin': {
      id: '/_unauthenticated/accountTypeLogin'
      path: '/accountTypeLogin'
      fullPath: '/accountTypeLogin'
      preLoaderRoute: typeof UnauthenticatedAccountTypeLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_unauthenticated/setup/': {
      id: '/_unauthenticated/setup/'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof UnauthenticatedSetupIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/setup/additional-info': {
      id: '/_unauthenticated/setup/additional-info'
      path: '/setup/additional-info'
      fullPath: '/setup/additional-info'
      preLoaderRoute: typeof UnauthenticatedSetupAdditionalInfoLazyRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/setup/terms-agreement': {
      id: '/_unauthenticated/setup/terms-agreement'
      path: '/setup/terms-agreement'
      fullPath: '/setup/terms-agreement'
      preLoaderRoute: typeof UnauthenticatedSetupTermsAgreementRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/setup/payment-selection': {
      id: '/_unauthenticated/setup/payment-selection'
      path: '/setup/payment-selection'
      fullPath: '/setup/payment-selection'
      preLoaderRoute: typeof UnauthenticatedSetupPaymentSelectionRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/setup/password-creation': {
      id: '/_unauthenticated/setup/password-creation'
      path: '/setup/password-creation'
      fullPath: '/setup/password-creation'
      preLoaderRoute: typeof UnauthenticatedSetupPasswordCreationRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/setup/identity-support': {
      id: '/_unauthenticated/setup/identity-support'
      path: '/setup/identity-support'
      fullPath: '/setup/identity-support'
      preLoaderRoute: typeof UnauthenticatedSetupIdentitySupportRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/setup/email-verification': {
      id: '/_unauthenticated/setup/email-verification'
      path: '/setup/email-verification'
      fullPath: '/setup/email-verification'
      preLoaderRoute: typeof UnauthenticatedSetupEmailVerificationRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/setup/create-link': {
      id: '/_unauthenticated/setup/create-link'
      path: '/setup/create-link'
      fullPath: '/setup/create-link'
      preLoaderRoute: typeof UnauthenticatedSetupCreateLinkRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/setup/check-existing-account': {
      id: '/_unauthenticated/setup/check-existing-account'
      path: '/setup/check-existing-account'
      fullPath: '/setup/check-existing-account'
      preLoaderRoute: typeof UnauthenticatedSetupCheckExistingAccountRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/setup/branch-informational': {
      id: '/_unauthenticated/setup/branch-informational'
      path: '/setup/branch-informational'
      fullPath: '/setup/branch-informational'
      preLoaderRoute: typeof UnauthenticatedSetupBranchInformationalRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/registration/token-exchange': {
      id: '/_unauthenticated/registration/token-exchange'
      path: '/registration/token-exchange'
      fullPath: '/registration/token-exchange'
      preLoaderRoute: typeof UnauthenticatedRegistrationTokenExchangeRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/account/debit-card': {
      id: '/_authenticated/account/debit-card'
      path: '/debit-card'
      fullPath: '/account/debit-card'
      preLoaderRoute: typeof AuthenticatedAccountDebitCardRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/_dashboard': {
      id: '/_authenticated/account/_dashboard'
      path: ''
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountDashboardRouteRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/_accountDetails': {
      id: '/_authenticated/account/_accountDetails'
      path: ''
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountAccountDetailsRouteRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/_dashboard/': {
      id: '/_authenticated/account/_dashboard/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedAccountDashboardRouteRoute
    }
    '/_unauthenticated/registration/password/exchange': {
      id: '/_unauthenticated/registration/password/exchange'
      path: '/registration/password/exchange'
      fullPath: '/registration/password/exchange'
      preLoaderRoute: typeof UnauthenticatedRegistrationPasswordExchangeRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/account/_accountDetails/personalInfo': {
      id: '/_authenticated/account/_accountDetails/personalInfo'
      path: '/personalInfo'
      fullPath: '/account/personalInfo'
      preLoaderRoute: typeof AuthenticatedAccountAccountDetailsPersonalInfoRouteImport
      parentRoute: typeof AuthenticatedAccountAccountDetailsRouteRoute
    }
    '/_authenticated/account/_accountDetails/connectedDebitCards': {
      id: '/_authenticated/account/_accountDetails/connectedDebitCards'
      path: '/connectedDebitCards'
      fullPath: '/account/connectedDebitCards'
      preLoaderRoute: typeof AuthenticatedAccountAccountDetailsConnectedDebitCardsRouteImport
      parentRoute: typeof AuthenticatedAccountAccountDetailsRouteRoute
    }
    '/_authenticated/account/_dashboard/onDemandPay': {
      id: '/_authenticated/account/_dashboard/onDemandPay'
      path: '/onDemandPay'
      fullPath: '/account/onDemandPay'
      preLoaderRoute: typeof AuthenticatedAccountDashboardOnDemandPayRouteRouteImport
      parentRoute: typeof AuthenticatedAccountDashboardRouteRoute
    }
    '/_authenticated/account/_dashboard/onDemandPay/': {
      id: '/_authenticated/account/_dashboard/onDemandPay/'
      path: '/'
      fullPath: '/account/onDemandPay/'
      preLoaderRoute: typeof AuthenticatedAccountDashboardOnDemandPayIndexRouteImport
      parentRoute: typeof AuthenticatedAccountDashboardOnDemandPayRouteRoute
    }
    '/_authenticated/account/_dashboard/onDemandPay/reportedWork': {
      id: '/_authenticated/account/_dashboard/onDemandPay/reportedWork'
      path: '/reportedWork'
      fullPath: '/account/onDemandPay/reportedWork'
      preLoaderRoute: typeof AuthenticatedAccountDashboardOnDemandPayReportedWorkRouteImport
      parentRoute: typeof AuthenticatedAccountDashboardOnDemandPayRouteRoute
    }
    '/_unauthenticated/registration/organizations/$orgId/exchange': {
      id: '/_unauthenticated/registration/organizations/$orgId/exchange'
      path: '/registration/organizations/$orgId/exchange'
      fullPath: '/registration/organizations/$orgId/exchange'
      preLoaderRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/registration/organizations/$orgId/exchange/': {
      id: '/_unauthenticated/registration/organizations/$orgId/exchange/'
      path: '/'
      fullPath: '/registration/organizations/$orgId/exchange/'
      preLoaderRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRouteImport
      parentRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute
    }
    '/_unauthenticated/registration/organizations/$orgId/exchange/workerPasscode': {
      id: '/_unauthenticated/registration/organizations/$orgId/exchange/workerPasscode'
      path: '/workerPasscode'
      fullPath: '/registration/organizations/$orgId/exchange/workerPasscode'
      preLoaderRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRouteImport
      parentRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute
    }
    '/_unauthenticated/registration/organizations/$orgId/exchange/orgPasscode': {
      id: '/_unauthenticated/registration/organizations/$orgId/exchange/orgPasscode'
      path: '/orgPasscode'
      fullPath: '/registration/organizations/$orgId/exchange/orgPasscode'
      preLoaderRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRouteImport
      parentRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute
    }
  }
}

interface AuthenticatedAccountAccountDetailsRouteRouteChildren {
  AuthenticatedAccountAccountDetailsConnectedDebitCardsRoute: typeof AuthenticatedAccountAccountDetailsConnectedDebitCardsRoute
  AuthenticatedAccountAccountDetailsPersonalInfoRoute: typeof AuthenticatedAccountAccountDetailsPersonalInfoRoute
}

const AuthenticatedAccountAccountDetailsRouteRouteChildren: AuthenticatedAccountAccountDetailsRouteRouteChildren =
  {
    AuthenticatedAccountAccountDetailsConnectedDebitCardsRoute:
      AuthenticatedAccountAccountDetailsConnectedDebitCardsRoute,
    AuthenticatedAccountAccountDetailsPersonalInfoRoute:
      AuthenticatedAccountAccountDetailsPersonalInfoRoute,
  }

const AuthenticatedAccountAccountDetailsRouteRouteWithChildren =
  AuthenticatedAccountAccountDetailsRouteRoute._addFileChildren(
    AuthenticatedAccountAccountDetailsRouteRouteChildren,
  )

interface AuthenticatedAccountDashboardOnDemandPayRouteRouteChildren {
  AuthenticatedAccountDashboardOnDemandPayReportedWorkRoute: typeof AuthenticatedAccountDashboardOnDemandPayReportedWorkRoute
  AuthenticatedAccountDashboardOnDemandPayIndexRoute: typeof AuthenticatedAccountDashboardOnDemandPayIndexRoute
}

const AuthenticatedAccountDashboardOnDemandPayRouteRouteChildren: AuthenticatedAccountDashboardOnDemandPayRouteRouteChildren =
  {
    AuthenticatedAccountDashboardOnDemandPayReportedWorkRoute:
      AuthenticatedAccountDashboardOnDemandPayReportedWorkRoute,
    AuthenticatedAccountDashboardOnDemandPayIndexRoute:
      AuthenticatedAccountDashboardOnDemandPayIndexRoute,
  }

const AuthenticatedAccountDashboardOnDemandPayRouteRouteWithChildren =
  AuthenticatedAccountDashboardOnDemandPayRouteRoute._addFileChildren(
    AuthenticatedAccountDashboardOnDemandPayRouteRouteChildren,
  )

interface AuthenticatedAccountDashboardRouteRouteChildren {
  AuthenticatedAccountDashboardOnDemandPayRouteRoute: typeof AuthenticatedAccountDashboardOnDemandPayRouteRouteWithChildren
  AuthenticatedAccountDashboardIndexRoute: typeof AuthenticatedAccountDashboardIndexRoute
}

const AuthenticatedAccountDashboardRouteRouteChildren: AuthenticatedAccountDashboardRouteRouteChildren =
  {
    AuthenticatedAccountDashboardOnDemandPayRouteRoute:
      AuthenticatedAccountDashboardOnDemandPayRouteRouteWithChildren,
    AuthenticatedAccountDashboardIndexRoute:
      AuthenticatedAccountDashboardIndexRoute,
  }

const AuthenticatedAccountDashboardRouteRouteWithChildren =
  AuthenticatedAccountDashboardRouteRoute._addFileChildren(
    AuthenticatedAccountDashboardRouteRouteChildren,
  )

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountAccountDetailsRouteRoute: typeof AuthenticatedAccountAccountDetailsRouteRouteWithChildren
  AuthenticatedAccountDashboardRouteRoute: typeof AuthenticatedAccountDashboardRouteRouteWithChildren
  AuthenticatedAccountDebitCardRoute: typeof AuthenticatedAccountDebitCardRoute
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountAccountDetailsRouteRoute:
    AuthenticatedAccountAccountDetailsRouteRouteWithChildren,
  AuthenticatedAccountDashboardRouteRoute:
    AuthenticatedAccountDashboardRouteRouteWithChildren,
  AuthenticatedAccountDebitCardRoute: AuthenticatedAccountDebitCardRoute,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteChildren {
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRoute
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRoute
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRoute
}

const UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteChildren: UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteChildren =
  {
    UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRoute:
      UnauthenticatedRegistrationOrganizationsOrgIdExchangeOrgPasscodeLazyRoute,
    UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRoute:
      UnauthenticatedRegistrationOrganizationsOrgIdExchangeWorkerPasscodeLazyRoute,
    UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRoute:
      UnauthenticatedRegistrationOrganizationsOrgIdExchangeIndexRoute,
  }

const UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteWithChildren =
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute._addFileChildren(
    UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteChildren,
  )

interface UnauthenticatedRouteChildren {
  UnauthenticatedAccountTypeLoginRoute: typeof UnauthenticatedAccountTypeLoginRoute
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
  UnauthenticatedRequestPasswordResetRoute: typeof UnauthenticatedRequestPasswordResetRoute
  UnauthenticatedIndexRoute: typeof UnauthenticatedIndexRoute
  UnauthenticatedRegistrationTokenExchangeRoute: typeof UnauthenticatedRegistrationTokenExchangeRoute
  UnauthenticatedSetupBranchInformationalRoute: typeof UnauthenticatedSetupBranchInformationalRoute
  UnauthenticatedSetupCheckExistingAccountRoute: typeof UnauthenticatedSetupCheckExistingAccountRoute
  UnauthenticatedSetupCreateLinkRoute: typeof UnauthenticatedSetupCreateLinkRoute
  UnauthenticatedSetupEmailVerificationRoute: typeof UnauthenticatedSetupEmailVerificationRoute
  UnauthenticatedSetupIdentitySupportRoute: typeof UnauthenticatedSetupIdentitySupportRoute
  UnauthenticatedSetupPasswordCreationRoute: typeof UnauthenticatedSetupPasswordCreationRoute
  UnauthenticatedSetupPaymentSelectionRoute: typeof UnauthenticatedSetupPaymentSelectionRoute
  UnauthenticatedSetupTermsAgreementRoute: typeof UnauthenticatedSetupTermsAgreementRoute
  UnauthenticatedSetupAdditionalInfoLazyRoute: typeof UnauthenticatedSetupAdditionalInfoLazyRoute
  UnauthenticatedSetupIndexRoute: typeof UnauthenticatedSetupIndexRoute
  UnauthenticatedRegistrationPasswordExchangeRoute: typeof UnauthenticatedRegistrationPasswordExchangeRoute
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute: typeof UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteWithChildren
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedAccountTypeLoginRoute: UnauthenticatedAccountTypeLoginRoute,
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
  UnauthenticatedRequestPasswordResetRoute:
    UnauthenticatedRequestPasswordResetRoute,
  UnauthenticatedIndexRoute: UnauthenticatedIndexRoute,
  UnauthenticatedRegistrationTokenExchangeRoute:
    UnauthenticatedRegistrationTokenExchangeRoute,
  UnauthenticatedSetupBranchInformationalRoute:
    UnauthenticatedSetupBranchInformationalRoute,
  UnauthenticatedSetupCheckExistingAccountRoute:
    UnauthenticatedSetupCheckExistingAccountRoute,
  UnauthenticatedSetupCreateLinkRoute: UnauthenticatedSetupCreateLinkRoute,
  UnauthenticatedSetupEmailVerificationRoute:
    UnauthenticatedSetupEmailVerificationRoute,
  UnauthenticatedSetupIdentitySupportRoute:
    UnauthenticatedSetupIdentitySupportRoute,
  UnauthenticatedSetupPasswordCreationRoute:
    UnauthenticatedSetupPasswordCreationRoute,
  UnauthenticatedSetupPaymentSelectionRoute:
    UnauthenticatedSetupPaymentSelectionRoute,
  UnauthenticatedSetupTermsAgreementRoute:
    UnauthenticatedSetupTermsAgreementRoute,
  UnauthenticatedSetupAdditionalInfoLazyRoute:
    UnauthenticatedSetupAdditionalInfoLazyRoute,
  UnauthenticatedSetupIndexRoute: UnauthenticatedSetupIndexRoute,
  UnauthenticatedRegistrationPasswordExchangeRoute:
    UnauthenticatedRegistrationPasswordExchangeRoute,
  UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRoute:
    UnauthenticatedRegistrationOrganizationsOrgIdExchangeRouteRouteWithChildren,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
